import { camelizeKeys } from 'humps';
import { post } from '@namespace/helpers';
import { apiRoutes } from './apiRoutes';

export { cancelLimit, initLimit, setLimit } from './limits';

export const setLimits = (body) =>
  post({
    url: apiRoutes.setLimits(),
    body,
    mode: 'cors'
  }).then(camelizeKeys);

export const getLimits = (body) =>
  post({
    url: apiRoutes.getLimits(),
    body,
    mode: 'cors'
  }).then(camelizeKeys);
